var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg18IcTvDisplayLive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,2 L2.5,2 C1.6675,2 1,2.6675 1,3.5 L1,12.5 C1,13.325 1.6675,14 2.5,14 L6.25,14 L6.25,15.5 L12.25,15.5 L12.25,14 L16,14 C16.825,14 17.4925,13.325 17.4925,12.5 L17.5,3.5 C17.5,2.6675 16.825,2 16,2 Z M16,12.5 L2.5,12.5 L2.5,3.5 L16,3.5 L16,12.5 Z M12.25,8 L7,11 L7,5 L12.25,8 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg18IcTvDisplayLive);
export default __webpack_public_path__ + "static/media/18_ic_tv_display_live.46938aa9.svg";
export { ForwardRef as ReactComponent };